import { Modal } from '../common/modal';
import GetACardTemplate from './GetACardModal.html';

export default class GetACardModal extends Modal {
    constructor() {
        const classes = ['GetACardModal'];
        if (window.featureManager.isEnabled('OzoneAuthentication')) {
            classes.push('extraPadding');
        }

        const content = GetACardTemplate();
        const modalContents = {
            classes,
            title: window.html('getCard.needCard'),
            hiddenTitle: true,
            content,
        };

        super(modalContents);

        this.$el.find('.button').on('click', () => {
            this._setCookie();
        });
    }

    close() {
        this._setCookie();
        super.close();
    }

    _setCookie() {
        Cookies.set('gacPromoDismissed', 1, {
            httpOnly: false,
            sameSite: 'lax',
            secure: true,
        });
    }
}
